function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import classNames from 'classnames';
import './fancy-text.less';
export default class FancyText extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "renderValue", (value, indent = 0) => {
      if (value === undefined) {
        return /*#__PURE__*/React.createElement("span", {
          className: "value-undefined"
        }, "undefined");
      } else if (value === null) {
        return /*#__PURE__*/React.createElement("span", {
          className: "value-null"
        }, "null");
      } else if (Array.isArray(value)) {
        return /*#__PURE__*/React.createElement("ul", {
          className: "value-array"
        }, value.map((item, i) => /*#__PURE__*/React.createElement("li", {
          key: i
        }, /*#__PURE__*/React.createElement(FancyText, {
          value: item,
          indent: indent + 1
        }))));
      } else if (typeof value === 'object') {
        return /*#__PURE__*/React.createElement("ul", {
          className: "value-object"
        }, Object.keys(value).map((key, i) => /*#__PURE__*/React.createElement("li", {
          key: i
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: `${indent * 12}px`
          },
          className: "value-object-key"
        }, key, ":"), /*#__PURE__*/React.createElement(FancyText, {
          value: value[key],
          indent: indent + 1
        }))));
      }
      const components = [];
      extractJson(value.toString()).forEach(possibleJson => {
        if (possibleJson.isJson) {
          components.push( /*#__PURE__*/React.createElement(FancyText, {
            value: possibleJson.parsed,
            indent: indent + 1
          }));
          return;
        }
        extratHtml(possibleJson.text).forEach(possibleHtml => {
          if (possibleHtml.isHtml) {
            components.push( /*#__PURE__*/React.createElement("iframe", {
              style: {
                display: 'block',
                width: '100%',
                border: 'none'
              },
              ref: iframe => {
                if (!iframe) {
                  return;
                }
                const root = iframe.contentWindow || iframe.contentDocument.document || iframe.contentDocument;
                root.document.open();
                root.document.write(possibleHtml.text);
                root.document.close();
                iframe.style.height = `${root.document.body.scrollHeight + 24}px`;
              }
            }));
            return;
          }
          extractLinks(possibleHtml.text).forEach(possibleLink => {
            if (possibleLink.isLink) {
              components.push( /*#__PURE__*/React.createElement("a", {
                href: possibleLink.text,
                target: "_blank",
                rel: "noreferrer"
              }, ` ${possibleLink.text} `));
              return;
            }
            components.push( /*#__PURE__*/React.createElement("span", null, possibleLink.text));
          });
        });
      });
      return /*#__PURE__*/React.createElement(Fragment, null, components);
    });
  }
  render() {
    const {
      classsName,
      value,
      indent,
      ...props
    } = this.props;
    return /*#__PURE__*/React.createElement("span", _extends({}, props, {
      className: classNames('fancy-text', classsName)
    }), this.renderValue(value, indent));
  }
}
function extractJson(value) {
  const results = [];
  let current = [];
  let inJson = 0;
  let inQuote = 0;
  for (let i = 0; i < value.length; i++) {
    if (inJson) {
      if (inQuote && value[i] === '"' && value[i - 1] !== '\\') {
        inQuote -= 1;
      } else if (!inQuote && value === '"') {
        inQuote += 1;
      } else if (!inQuote && value[i] === '{') {
        inJson += 1;
      } else if (!inQuote && value[i] === '}') {
        inJson -= 1;
        if (!inJson) {
          current.push('}');
          results.push({
            isJson: true,
            text: current.join('')
          });
          current = [];
        }
      } else {
        current.push(value[i]);
      }
    } else if (value[i] === '{') {
      if (current.length > 0) {
        results.push({
          isJson: false,
          text: current.join('')
        });
      }
      inJson += 1;
      current = ['{'];
    } else {
      current.push(value[i]);
    }
  }
  if (current.length > 0) {
    results.push({
      isJson: false,
      text: current.join('')
    });
  }

  // parse any json to make sure it's valid
  const parsedResults = [];
  results.forEach(possibleJson => {
    if (possibleJson.isJson) {
      try {
        possibleJson.parsed = JSON.parse(possibleJson.text);
      } catch {
        possibleJson.isJson = false;
      }
    }
    // combine any non json results if they are consecutive
    if (possibleJson.isJson) {
      parsedResults.push(possibleJson);
    } else if (parsedResults.length === 0 || parsedResults[parsedResults.length - 1].isJson) {
      parsedResults.push(possibleJson);
    } else {
      parsedResults[parsedResults.length - 1].text = `${parsedResults[parsedResults.length - 1].text} ${possibleJson.text}`;
    }
  });
  return parsedResults;
}
function extratHtml(value) {
  const results = [];
  let current = [];
  let inHtml = 0;
  value.split(' ').forEach(word => {
    if (!word) {
      return;
    }
    if (inHtml) {
      if (word.toLowerCase().indexOf('</html>') >= 0) {
        const endIndex = word.toLowerCase().indexOf('</html>');
        inHtml -= 1;
        current.push(word.substring(0, endIndex + 7));
        results.push({
          isHtml: true,
          text: current.join(' ')
        });
        current = [];
        const extraWord = word.substring(endIndex + 7);
        if (extraWord) {
          current.push(extraWord);
        }
      } else {
        current.push(word);
      }
    } else if (word.toLowerCase().indexOf('<!doctype') === 0 || word.toLowerCase().indexOf('<html>') === 0) {
      inHtml += 1;
      if (current.length > 0) {
        results.push({
          isHtml: false,
          text: current.join(' ')
        });
      }
      if (word.toLowerCase().indexOf('</html>') >= 0) {
        const endIndex = word.toLowerCase().indexOf('</html>');
        results.push({
          isHtml: true,
          text: word.substring(0, endIndex + 7)
        });
        current = [];
        const extraWord = word.substring(endIndex + 7);
        if (extraWord) {
          current.push(extraWord);
        }
      } else {
        current = [word];
      }
    } else {
      current.push(word);
    }
  });
  if (current.length > 0) {
    results.push({
      isHtml: false,
      text: current.join(' ')
    });
  }
  return results;
}
function extractLinks(value) {
  const results = [];
  const current = [];
  value.split(' ').forEach(word => {
    if (!word) {
      return;
    }
    if (word.toLowerCase().indexOf('http://') === 0 || word.toLowerCase().indexOf('https://') === 0) {
      if (current.length > 0) {
        results.push({
          isLink: false,
          text: current.join(' ')
        });
      }
      results.push({
        isLink: true,
        text: word
      });
    } else {
      current.push(word);
    }
  });
  if (current.length > 0) {
    results.push({
      isLink: false,
      text: current.join(' ')
    });
  }
  return results;
}
//# sourceMappingURL=fancy-text.js.map